import { useNavigate } from "react-router";
import { Button } from "react-bootstrap";

export default function Unauthorized() {
  // *************
  // TO DO

  // Style
  // *************

  const navigate = useNavigate();
  return (
    <section className="chroma-section">
      <section className="section-content">
        <p>Unauthorized Access</p>
        <section className="sub-section">I am a sub section</section>
      </section>
    </section>
  );
}
